import { X } from "lucide-react";

import explainerPoster from "@assets/images/hsa-fsa/explainer-poster.webp";
import Dialog from "@/blueprint/components/Dialog/Dialog";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { HSA_FSA_STEPS } from "@/views/hsa-fsa/hsaFsaContent";

type Props = { open: boolean; onClose: () => void };

/* One video serves every breakpoint; mobile crops it to the chat pane here. */
const MOBILE_CROP =
  "left-[-12.74%] top-[-27.76%] h-[128.24%] w-[229.57%] max-w-none";

const HsaFsaExplainerModal = ({ open, onClose }: Props) => {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label={HSA_FSA_STEPS.explainer.dialogLabel}
      dismissOnBackdropClick
      className="fixed inset-0 z-[100] flex items-center justify-center bg-tint-pure-black-20 px-[18px] py-[18px] tab:px-[32px] tab:py-[50px] sd:px-[64px]"
    >
      {/* [aspect-ratio:] rather than aspect-[...]: this repo disables the core
          aspectRatio plugin, so aspect-[...] emits nothing. */}
      <div className="relative w-full overflow-hidden rounded-s [aspect-ratio:1304/1332] tab:max-w-[770px] tab:[aspect-ratio:2994/1708] sd:max-w-[1152px] d:max-w-[1600px]">
        <video
          src={HSA_FSA_STEPS.explainer.videoSrc}
          poster={explainerPoster.src}
          autoPlay={!reducedMotion}
          muted
          loop={!reducedMotion}
          playsInline
          preload="metadata"
          aria-label={HSA_FSA_STEPS.explainer.mediaAlt}
          /* Without autoplay, reduced motion needs a way to start the video. */
          controls={reducedMotion}
          className={`absolute object-cover tab:inset-0 tab:size-full ${MOBILE_CROP}`}
        />
        <button
          type="button"
          onClick={onClose}
          aria-label={HSA_FSA_STEPS.explainer.closeLabel}
          className="absolute right-0 top-0 flex size-[64px] items-center justify-center p-[16px] tab:size-[72px] tab:p-[20px] sd:size-[80px] sd:p-[24px] d:size-[96px] d:p-[32px]"
        >
          <X aria-hidden className="size-[32px] text-brand-black" />
        </button>
      </div>
    </Dialog>
  );
};

export default HsaFsaExplainerModal;
